import React from 'react';
import PropTypes from 'prop-types';
import className from 'classnames';
import { useTranslation } from 'react-i18next';

const KidsDropdownNative = ({ value, list, onSelectKidAge, showKidError }) => {
    const { t } = useTranslation();
    const label = t('roomSelector.dropdown.text');
    const handleChange = (event) => {
        onSelectKidAge( parseInt(event.target.value) );
    };
    const classNamesInput = className({
        'odf-input-group': true,
        'invalid': showKidError && value === -1,
    });
    return (
        <div className={classNamesInput} data-testid="kids-dropdown">
            <select className="odf-input odf-select" value={value} onChange={handleChange}>
                <option value={-1}>{label}</option>
                { list.map((item) => (
                    <option key={item} value={item}>{label}: {item}</option>
                )) }
            </select>
            <span className="odf-input-append odf-icon odf-icon-arrow-down" />
        </div>
    );
};

KidsDropdownNative.propTypes = {
    value: PropTypes.number.isRequired,
    list: PropTypes.arrayOf(PropTypes.number).isRequired,
    onSelectKidAge: PropTypes.func.isRequired,
    showKidError: PropTypes.bool.isRequired,
};

export { KidsDropdownNative };
